var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDelivering = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0834961 3.5H9.8335L10.5835 5H0.833496L0.0834961 3.5ZM1.0835 6.5H10.8335L11.5835 8H1.8335L1.0835 6.5ZM17.3335 14.5C18.1635 14.5 18.8335 13.83 18.8335 13C18.8335 12.17 18.1635 11.5 17.3335 11.5C16.5035 11.5 15.8335 12.17 15.8335 13C15.8335 13.83 16.5035 14.5 17.3335 14.5ZM18.8335 5.5H16.3335V8H20.7935L18.8335 5.5ZM7.3335 14.5C8.1635 14.5 8.8335 13.83 8.8335 13C8.8335 12.17 8.1635 11.5 7.3335 11.5C6.5035 11.5 5.8335 12.17 5.8335 13C5.8335 13.83 6.5035 14.5 7.3335 14.5ZM19.3335 4L22.3335 8V13H20.3335C20.3335 14.66 18.9935 16 17.3335 16C15.6735 16 14.3335 14.66 14.3335 13H10.3335C10.3335 14.66 8.9835 16 7.3335 16C5.6735 16 4.3335 14.66 4.3335 13H2.3335V9.5H4.3335V11H5.0935C5.6435 10.39 6.4435 10 7.3335 10C8.2235 10 9.0235 10.39 9.5735 11H14.3335V2H2.3335C2.3335 0.89 3.2235 0 4.3335 0H16.3335V4H19.3335Z",
    fill: "#0DAB01"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDelivering);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_delivering.d7db5f4dd525ff8947d1794963dbed5f.svg";